export { default as AnalyticsCompetencies } from './AnalyticsCompetencies';
export { default as AnalyticsCompetenciesChart } from './AnalyticsCompetenciesChart';
export { default as AnalyticsCompetenciesFilters } from './AnalyticsCompetenciesFilters';
export { default as AnalyticsCompetenciesList } from './AnalyticsCompetenciesList';
export { default as AnalyticsCourses } from './AnalyticsCourses';
export { default as AnalyticsCoursesCategoryFilter } from './AnalyticsCoursesCategoryFilter';
export { default as AnalyticsCoursesCompletions } from './AnalyticsCoursesCompletions';
export { default as AnalyticsCoursesList } from './AnalyticsCoursesList';
export { default as AnalyticsCoursesListCourse } from './AnalyticsCoursesListCourse';
export { default as AnalyticsCoursesMostPopular } from './AnalyticsCoursesMostPopular';
export { default as AnalyticsCoursesSummary } from './AnalyticsCoursesSummary';
export { default as AnalyticsDataWithChart } from './AnalyticsDataWithChart';
export { default as AnalyticsDeletedUsersWarning } from './AnalyticsDeletedUsersWarning';
export { default as AnalyticsGroupFilter } from './AnalyticsGroupFilter';
export { default as AnalyticsOverview } from './AnalyticsOverview';
export { default as AnalyticsOverviewContent } from './AnalyticsOverviewContent';
export { default as AnalyticsOverviewLogins } from './AnalyticsOverviewLogins';
export { default as AnalyticsOverviewUsers } from './AnalyticsOverviewUsers';
export { default as AnalyticsPaths } from './AnalyticsPaths';
export { default as AnalyticsPathsPath } from './AnalyticsPathsPath';

// wrap components with feature flag handling so we can keep import
// always from components/analytics. When we finally release this and
// remove the feature flag guard, we will just delete this entire folder
// and rename the /components/analytics-new folder to /components/analytics
import { useReduxState } from 'hooks';

import AnalyticsPageLegacy from './AnalyticsPage';
import AnalyticsPageNew from '../analytics-new/AnalyticsPage';
const AnalyticsPage = (props) => {
  const {
    serverConfig: { featureFlags }
  } = useReduxState();
  const Component = featureFlags.enableNewAnalytics
    ? AnalyticsPageNew
    : AnalyticsPageLegacy;
  return <Component {...props} />;
};

export { AnalyticsPage };
export { default as AnalyticsActivity } from '../analytics-new/AnalyticsActivity';
export { default as AnalyticsDetailed } from '../analytics-new/AnalyticsDetailed';
export { default as AnalyticsSuperadmin } from '../analytics-new/AnalyticsSuperadmin';
export { default as AnalyticsCompletionHistory } from '../analytics-new/AnalyticsCompletionHistory';
export { default as AnalyticsPageFilters } from '../analytics-new/AnalyticsPageFilters';
export { default as AnalyticsPageFiltersContentTypes } from '../analytics-new/AnalyticsPageFiltersContentTypes';
